import useValidationSchema from '../../Hooks/useValidationSchema'
import useConfigTransform from '../../Hooks/useConfigTransform'
import NumberComponent from './Components/OffNumberComponent'

const NumberField = () => {
  const { getCurrentSchema } = useValidationSchema()
  const { getCurrentTransform } = useConfigTransform()

  return {
    validationSchema: getCurrentSchema('attributes/offNumberField'),
    configTransform: getCurrentTransform('attributes/readOnly'),
    Component: NumberComponent,
    CoVComponent: () => null
  }
}

export default NumberField
